import {
    ExternalBulkDryGoods,
    ExternalBulkLiquidGoods,
    ExternalCargoEmptiesGoods,
    ExternalCargoMaterialGoods,
    ExternalGoodsType,
    ExternalHazardClass,
    ExternalPackableType,
    ExternalPackingGroup,
    ExternalTunnelRestrictionCode,
} from "../client/transportorder-hub/goods.model"

export const createExternalGoodsCargoMaterial = (): ExternalCargoMaterialGoods => ({
    type: ExternalGoodsType.CARGO_MATERIAL,
    handling_units: [
        {
            type: ExternalPackableType.HANDLING_UNIT,
            packaging_code: "8036541",
            quantity: 3,
            stacking_factor: 2,
            dimension: {
                length_m: 0.4183,
                width_m: 1.4623,
                height_m: 4.547
            },
            weight: {
                gross_weight_kg: 18.257800000000003,
            },
            content: [
                {
                    type: ExternalPackableType.ARTICLE,
                    id: "Gorgeous Copper Plate",
                    quantity: {
                        value: 613
                    },
                    dangerous_goods_information: {
                        undg: "3406",
                        description: "Barium perchlorate",
                        exception_regulation: "Probably fine",
                        hazard_class: ExternalHazardClass.CLASS_4_2,
                        packing_group: ExternalPackingGroup.II,
                        tunnel_restriction_code: ExternalTunnelRestrictionCode.C5000D,
                    },
                    internal_place_of_destination: {
                        id: "37233",
                    },
                    country_of_origin: {
                        country_code: "DE",
                        dutiable_goods: false,
                    },
                }
            ]
        }
    ]
})

export const createExternalGoodsCargoEmpties = (): ExternalCargoEmptiesGoods => ({
    type: ExternalGoodsType.CARGO_EMPTIES,
    handling_units: [
        {
            packaging_code: "8036541",
            quantity: 3,
            stacking_factor: 2,
            dimension: {
                length_m: 0.4183,
                width_m: 1.4623,
                height_m: 4.547
            },
            gross_weight_kg: 18.257800000000003,
            content: [
                {
                    id: "Gorgeous Copper Plate",
                    quantity: 613,
                    dangerous_goods_information: {
                        undg: "3406",
                        description: "Barium perchlorate",
                    },
                }
            ]
        }
    ]
})

export const createExternalGoodsBulk = (type: ExternalGoodsType.BULK_DRY | ExternalGoodsType.BULK_LIQUID): ExternalBulkDryGoods | ExternalBulkLiquidGoods => ({
    type,
    dangerous_goods_information: {
        undg: "3406",
        description: "Barium perchlorate",
    },
    article_id: "Car wheels",
    volume_m3: 11,
    weight_kg: 42.1,
})
